<template>
    <div class="contrast-switch-wrapper">
        <div class="contrast-switch custom-control custom-switch">
            <label :class="highContrast ? 'checkbox-checked' : 'checkbox-unchecked'" class="custom-control-label">
                {{ highContrastText }}

                <input
                    @change="handleChange"
                    v-model="highContrast"
                    type="checkbox"
                    class="custom-control-input"
                >
            </label>
        </div>

        <span aria-hidden="true">
            <template v-if="highContrast">
                {{ onText }}
            </template>
            <template v-if="!highContrast">
                {{ offText }}
            </template>
        </span>
    </div>
</template>

<script>
export default {
    name: 'HighContrastSwitch',

    data() {
        return {
            highContrast: false,

            highContrastText: window.Drupal.t('High contrast'),
            onText: window.Drupal.t('On'),
            offText: window.Drupal.t('Off')
        }
    },

    mounted() {
        this.checkInitialState()

        window.eventBus.$on('high-contrast-toggled', (payload) => {
            if (payload) {
                this.highContrast = true
                return;
            }

            this.highContrast = false
        })
    },

    methods: {
        handleChange() {
            if (this.highContrast) {
                localStorage.setItem('high-contrast', '1')
                document.body.classList.add('high-contrast');

                window.eventBus.$emit('high-contrast-toggled', true)
                return;
            }

            document.body.classList.remove('high-contrast');
            window.eventBus.$emit('high-contrast-toggled', false)
            localStorage.removeItem('high-contrast')
        },

        checkInitialState() {
            if (_.isNil(localStorage.key('high-contrast'))) {
                return
            }

            this.highContrast = true
            document.body.classList.add('high-contrast')
        }
    }
}
</script>